import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';

import StringConstants from '../../constants/StringConstants';
import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';
import makeRequest from '../../utils/makeRequestUtils';
import useRequestConfig from '../../hooks/useRequestConfig';

type DeactivationLeasesSurveyParams = {
  listingAlias: string;
  type: string;
  value: boolean;
};

/**
 * Sends deactivation leases survey responses
 *
 * @param {string} listingAlias
 * @param {string} type
 * @param {boolean} value
 */
export const useSubmitDeactivationLeasesSurvey = (queryOptions = {}) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig(StringConstants.POST);

  const mutationFn = (queryParams: DeactivationLeasesSurveyParams) => {
    const { listingAlias, type, value } = queryParams;
    return makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V1_PREFIX}/users/properties/deactivate/leases?listingAlias=${listingAlias}&type=${type}&value=${value}`,
      requestConfig,
    });
  };

  return useMutation({ mutationFn, ...queryOptions });
};
